package net.frozenbit.games.soundgame.audio

import kotlin.jvm.JvmInline

interface AudioPlayer {
    /**
     * Starts playing the music file located at the given [path]. This will
     * stop any currently playing music and start the new one.
     */
    fun prepareMusic(path: String, loop: Boolean = false)
    fun pauseMusic()
    fun resumeMusic()
    fun seekMusic(position: Double)
    fun getMusicPosition(): Double
    fun stopMusic()

    fun addMusicCompletionListener(listener: () -> Unit): EventHandlerHandle
    fun removeMusicCompletionListener(handle: EventHandlerHandle)

    fun setMusicVolume(volume: Double)
    fun getMusicVolume(): Double


    /**
     * Prepares the given audio file content for playback. The caller is responsible
     * to provide a supported format (e.g., WAV, MP3, OGG) and to manage the lifecycle
     * of the audio data by calling [release] when the audio is no longer needed.
     */
    suspend fun prepare(buffer: ByteArray): AudioHandle

    /**
     * Plays the audio associated with the given [AudioHandle] at the specified [volume].
     * Returns when the playback is finished.
     */
    suspend fun play(handle: AudioHandle, volume: Float = 1.0f)

    /**
     * Releases the resources associated with the given [AudioHandle]. After calling this method,
     * the handle must not be used for playback anymore.
     */
    suspend fun release(handle: AudioHandle)
}

@JvmInline
value class AudioHandle(val audioId: String)

@JvmInline
value class EventHandlerHandle(val handlerId: String)
